export default {
  active: null,

  init() {
    document.querySelectorAll('[href^="#modal-"]').forEach(($link) => {
      $link.addEventListener("click", (ev) => {
        ev.preventDefault();
        this.toggle($link.getAttribute("href").replace("#modal-", ""));
      });
    });

    window.addEventListener("open-modal", (ev) => {
      this.open(ev.detail);
    });

    window.addEventListener("close-modal", () => {
      this.close();
    });
  },

  isOpen(modal) {
    return this.active === modal;
  },

  open(modal) {
    this.active = modal;

    document
      .querySelectorAll(`#modal-${this.active} video`)
      .forEach(($video) => {
        $video.play();
      });
  },

  close() {
    if (!this.active) {
      return;
    }

    document
      .querySelectorAll(`#modal-${this.active} video`)
      .forEach(($video) => {
        $video.pause();
      });

    this.active = null;
  },

  toggle(modal) {
    if (this.isOpen(modal)) {
      this.close();
    } else {
      this.open(modal);
    }
  },
};
